module.exports = __webpack_public_path__ + "media/St 4-refrigerator-question.f2257f75.wav";